import React, { useEffect, useState } from "react";
import { useParams } from "react-router-dom";
import { useTranslation } from "react-i18next";
import { fetchWooProductBySlug } from "../../api/wooService";
import { useLoading } from "../../contexts/LoadingContext";
import SeoMeta from "../../components/SeoMeta";

import ProductTitleSection from "./components/ProductTitleSection";
import FooterOfficina from "./components/FooterOfficina";


const ProductPage = () => {
  const { slug } = useParams();
  const { t } = useTranslation();
  const { setIsLoading } = useLoading();
  const [product, setProduct] = useState(null);
  const [error, setError] = useState(null);

  useEffect(() => {
    const fetchProduct = async () => {
      setIsLoading(true);
      try {
        const data = await fetchWooProductBySlug(slug);
        if (!data) throw new Error("Product not found");
        setProduct(data);
      } catch (err) {
        console.error("❌ WooCommerce fetch error:", err.message);
        setError(err.message);
      } finally {
        setIsLoading(false);
      }
    };

    fetchProduct();
  }, [slug, setIsLoading]);

  if (error) return <p className="text-danger text-center my-5">{error}</p>;
  if (!product) return null;

  const hasExternalLink = product.permalink?.length > 0;
  const attributes = product.attributes || [];

  const stripHtml = (html) => {
	  const div = document.createElement("div");
	  div.innerHTML = html;
	  return div.textContent || div.innerText || "";
	};
  
  
  return (
    <>
	<SeoMeta
        title={product.name}
        description={stripHtml(product.short_description)}
        keywords={t("officina.SeoKeywords")}
        robots="index, follow"
      />
		
	<ProductTitleSection
	  title={product.name}
	  image={product.images?.[0]?.src}
	  priceHtml={product.price_html}
	  shortDescription={product.short_description}
	  description={stripHtml(product.short_description)}
	  attributes={product.attributes}
	  externalUrl={product.permalink}
	  stockStatus={product.stock_status}
	/>
  
	<FooterOfficina />
		
  </>
  );
};

export default ProductPage;